<div class="chat-item-container" [class.selected]="isSelected()" (click)="selectItem.emit()">
  @let statusWithDescription = status() | userStatusDescription: isGroupChat();
  @let userStatusDescription = status() | userStatusDescription: isGroupChat() : false : true;
  <div class="image-container">
    <be-user-avatar
      [avatar]="imageSrc()"
      [initials]="title() | initials"
      [colorInfo]="colorInfo()"
      [isGroupChat]="isGroupChat()"
      [status]="status()"
      [blazeTooltip]="statusWithDescription"
      matTooltipClass="whitespace-pre-line [text-align-last:left]"
      matTooltipPosition="above"
    />
  </div>

  <div class="title" data-cy="ChatListItem:title">
    {{ title() }}
    @if (userStatusDescription) {
      <span
        [blazeTooltip]="userStatusDescription"
        matTooltipClass="whitespace-pre-line [text-align-last:left]"
        matTooltipPosition="above"
        >💬</span
      >
    }
  </div>

  @if (unreadCountDisplayValue()) {
    <div class="unread-count">
      {{ unreadCountDisplayValue() }}
    </div>
  }
  <div>
    <ng-content />
  </div>
</div>
